import { BaseContract } from 'ethers';

export const getContractDecimals = async (contract: BaseContract) => {
  const [decimals] = await contract.functions.decimals();

  return decimals;
};
